import {NODE_MODULE_PATH} from "../../utils/constants";

const createModuleCrudDtoActions = [
    {
        type: 'addMany',
        destination:
            'src/core/modules/{{dasherize moduleName}}/dtos/{{dasherize modelName}}',
        templateFiles: `${NODE_MODULE_PATH}/templates/nest/core/modules/dtos/garment/*.hbs`,
        base: `${NODE_MODULE_PATH}/templates/nest/core/modules/dtos/garment/`,
    },
];

export default createModuleCrudDtoActions;
